import HttpService from './HttpService';
import { getUrlPlantApi, translate, showMessageToastCustom, getApiKeyLogistics } from '../utils/util';
import { startLoading, endLoading } from '../actions/loadingAction';
import * as areaAction from '../actions/areaAction';
import * as actionsConfig from '../actions/configAction';

const httpService = new HttpService(getUrlPlantApi(window), getApiKeyLogistics(window));

export default class AreaService {
    static getAreas(vision, filter, pagination) {
        pagination.PageSize = 40;
        Object.assign(filter, pagination);
        const url = 'api/area';
        return (dispatch) => {
            if (navigator.onLine) {
                // dispatch(startLoading());
                httpService.instance.get(
                    url,
                    {
                        params: filter,
                        timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT,
                        timeoutErrorMessage: translate('general.timeout')
                    }
                ).then((response) => {
                    if (response.status === 200) {
                        dispatch(areaAction.setAreas(response.data.data));
                        dispatch(actionsConfig.updateSheds(response.data.data));

                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static AddArea = (area, callback) => {
        const url = 'api/area';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.post(url, area, { timeout: 360000, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback(response?.data?.data);
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), response?.data?.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static PutArea = (area, callback) => {
        const url = 'api/area';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, area, { timeout: 360000, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback(response.data);
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), response?.data?.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static DeleteArea = (areaId, callback) => {
        const url = 'api/area';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.delete(`${url}/${areaId}`, { timeout: 360000, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback({ message: "Item excluido com sucesso" });
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), response?.data?.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static DeleteSelectedAreas(ids, callback) {
        if (navigator.onLine) {
            const url = `/api/area/selected`;
            return (dispatch) => {
                if (navigator.onLine) {
                    dispatch(startLoading());
                    httpService.instance.put(url, ids, { timeout: 360000, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                        if (response.status === 200) {
                            if (callback) {
                                callback({ message: "Itens excluidos com sucesso" });
                            }
                        } else {
                            showMessageToastCustom(translate('warning', 'general'), response?.data?.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                        }
                    }).catch((error) => {
                        dispatch(endLoading());
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
                }
            };
        }
    }
}
